import { useTranslation as useI18nTranslation } from 'react-i18next';
import type { TranslateData } from '@/graphql/types/translate';

type FlattenKeys<T, P extends string = ''> = {
  [K in keyof T]: T[K] extends Record<string, unknown>
    ? FlattenKeys<T[K], `${P}${K & string}.`>
    : `${P}${K & string}`;
}[keyof T];

export type TranslationKey = FlattenKeys<TranslateData>;

export function useTranslation() {
  const { t, ...rest } = useI18nTranslation<'translation', undefined>();

  const tKeyed = (key: TranslationKey) => t(key) || key;

  return { t: tKeyed, ...rest };
}
